"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectionButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = require("lodash");
var _useUniqueHtmlId = require("../../utils/useUniqueHtmlId");
var _ = require("./..");
var _excluded = ["type", "wrapperStyles", "showCloseIcon", "buttonStyles", "children", "selected", "disabled", "name", "inputType"]; // For some reason importing this from '@utils' in Storybook
// causes useUniqueHtmlId to be undefined
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var SelectionButttonGroup = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    name = _ref.name,
    value = _ref.value,
    inputType = _ref.inputType,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _lodash.noop : _ref$onChange;
  var childArray = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children);
  }, [children]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, childArray.map(function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      name: name,
      inputType: inputType,
      // TODO: for some reason, if the value in props is a Number
      // the value becomes stringified when passed back as event.target.value.
      // For now, stringify both values first to be able to use the strict equality (===) operator
      checked: String(value) === String(child.props.value),
      onChange: onChange,
      ref: ref
    });
  }));
});
// TODO: Handle inputType checkbox
var SelectionButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var type = _ref2.type,
    wrapperStyles = _ref2.wrapperStyles,
    showCloseIcon = _ref2.showCloseIcon,
    buttonStyles = _ref2.buttonStyles,
    children = _ref2.children,
    selected = _ref2.selected,
    disabled = _ref2.disabled,
    name = _ref2.name,
    inputType = _ref2.inputType,
    props = _objectWithoutProperties(_ref2, _excluded);
  // Associate element containing text to checkbox for accessibility
  var id = (0, _useUniqueHtmlId.useUniqueHtmlId)("selection-".concat(name));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('selection-button-wrapper relative tw-body-sm-medium', wrapperStyles)
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    type: inputType,
    className: (0, _classnames.default)('selection-button-peer opacity-0 absolute top-0 left-0 w-full h-full cursor-pointer disabled:cursor-not-allowed'),
    checked: selected,
    disabled: disabled,
    name: name,
    id: id,
    ref: ref
  }, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('selection-button w-full tw-body-sm-medium', buttonStyles, {
      'h-[36px] rounded-[50px] tw-body-sm-regular': type === 'pill'
    })
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, children), showCloseIcon && /*#__PURE__*/_react.default.createElement(_.Icon, {
    type: "close-16",
    className: "channel-search__close-icon ml-[5px]",
    size: 9
  })));
});
var SelectionButtonNamespace = Object.assign(SelectionButton, {
  Group: SelectionButttonGroup
});
exports.SelectionButton = SelectionButtonNamespace;